<template>
  <div>
    <beast-header/>
    <div class="container">
      <beast-search-box
        v-on:searchEnded="updateSearch"/>
      <div class="row">
        <div class="col-12 beast-organization-header">
          <h1 v-text="org.slug"></h1>
        </div>
      </div>
      <div class="row">
        <div class="col-3 beast-organization-sidebar">
          <ul class="beast-sidebar-otherinfo">
            <li class="beast-sidebar-header">
              Organization Information
            </li>
            <li class="beast-sidebar-info">
              <strong>Name</strong>
              <span v-text="org.name"></span>
            </li>
            <li class="beast-sidebar-info">
              <strong>Slug</strong>
              <span v-text="org.slug"></span>
            </li>
            <li class="beast-sidebar-info">
              <strong>Owner</strong>
              <router-link :to="`/profile/${org.Owner.username}`">
                {{org.Owner.username}}
              </router-link>
            </li>
            <li class="beast-sidebar-info">
              <strong>Type</strong>
              <span v-text="org.translatedType"></span>
            </li>
          </ul>
        </div>
        <div class="col-9 beast-organization-info">
          <div class="row beast-tab">
            <router-link tag="div" :class="`col-${howMany} beast-tab-button`" :to="`${webURL}`"
                         exact-active-class="beast-tab-active">
              <a>Packages ({{org.packages}})</a>
            </router-link>
            <router-link tag="div" :class="`col-${howMany} beast-tab-button`" :to="`${webURL}/members`"
                         exact-active-class="beast-tab-active">
              <a>Members ({{org.members}})</a>
            </router-link>
            <router-link tag="div" :class="`col-${howMany} beast-tab-button`" :to="`${webURL}/teams`"
                         v-if="org.isMember"
                         exact-active-class="beast-tab-active">
              <a>Teams</a>
            </router-link>
            <router-link tag="div" :class="`col-${howMany} beast-tab-button`" :to="`${webURL}/edit`"
                         v-if="org.allowedToEdit"
                         exact-active-class="beast-tab-active">
              <a>Edit Info</a>
            </router-link>
          </div>
          <div class="row beast-tab-display">
            <div class="col-12">
              <router-view :org="org" :key="slug" @updateSearch="updateSearch" @readData="readData"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <beast-footer/>
  </div>
</template>

<style scoped lang="scss">
  .beast-organization-header {
    h1 {
      margin-left: 5px;
    }
  }

  .beast-tab {
    div {
      text-align: center;
      font-weight: bold;
      font-size: 13pt;
      a {
        color: $beast-dark-gray;
        text-decoration: none;
        display: block;
        line-height: 50px;
        border: 1px solid $beast-light-gray;
        border-radius: 15px 15px 0 0;
        border-bottom: none;
      }

      &:hover, &.beast-tab-active {
        a {
          background-color: $beast-green;
          color: $beast-white;
        }
      }
    }
  }

  .beast-tab-display{
    border-top: 1px solid $beast-light-gray;
    padding-top: 10px;
  }

  .beast-organization-sidebar {
    margin-top: 46px;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      font-size: 12pt;

      li {
        margin-bottom: 5px;
        padding: 3px 5px;
      }
    }

    .beast-sidebar-otherinfo {
      margin-top: 5px;
      padding-top: 12px;
      border-top: 1px solid #dcdcdc;

      .beast-sidebar-info {
        strong {
          display: block;
        }
      }
    }

    .beast-sidebar-header {
      font-weight: bold;
      margin-bottom: 2px;
      background: none;
      color: $beast-dark-gray;
      font-size: 14pt;
    }
  }
</style>

<script>
import BeastHeader from "../../components/header/BeastHeader.vue";
import BeastFooter from "../../components/footer/BeastFooter.vue";
import BeastSearchBox from "../../components/packages/BeastSearchBox.vue";

export default {
  components: {
    BeastSearchBox,
    BeastFooter,
    BeastHeader
  },
  props: {
    slug: String,
  },
  computed: {
    webURL() {
      return `/organization/${this.slug}`;
    },
    howMany() {
      if (this.org.isMember && this.org.allowedToEdit) {
        return 3;
      }
      if (this.org.isMember || this.org.allowedToEdit) {
        return 4;
      }

      return 6;
    }
  },
  data() {
    return {
      org: {
        id: "",
        name: "",
        slug: "",
        translatedType: "",
        packages: 0,
        members: 0,
        Owner: {
          username: ""
        }
      }
    };
  },
  watch: {
    async slug() {
      await this.readData();
    }
  },
  methods: {
    updateSearch(packageName) {
      this.$router.push({
        name: "search",
        query: {
          name: packageName
        }
      });
    },
    async readData() {
      const response = await this.axios.get(`/organizations/${this.slug}`);
      this.org = response.data;
      this.setTitle(`Organization: ${this.org.name}`);
    }
  },

  async beforeMount() {
    await this.readData();
  }
};
</script>
